import { ListStoreConstructor } from "stores/ListStoreConstructor";

export const hasNonDefaultValues = (currentValue: any, defaultValue: any): boolean => {
  if (Array.isArray(currentValue)) {
    return currentValue.length > 0 && !currentValue.every((val, index) => val === defaultValue?.[index]);
  }
  return currentValue !== defaultValue;
};

export const hasNonDefaultFiltersApplied = (store: ListStoreConstructor<any>) => {
  const hasNonDefaultFilters = Object.keys(store.filters || {}).some((key) =>
    hasNonDefaultValues(store.filters?.[key], store.defaultFilters?.[key])
  );

  return hasNonDefaultFilters;
};
